import { GetCustomerTypes, GetCustomerTypesToken } from "$src/application/customers/queries/GetCustomerTypes";
import { CustomerType } from "$src/domain/customers/CustomerType";
import { useQuery } from "@sveltestack/svelte-query";
import { container } from "tsyringe";

export async function fetchTypes(groupStoreId: number): Promise<CustomerType[]> {
   
    const query = container.resolve<GetCustomerTypes>(GetCustomerTypesToken);
    return query.execute(groupStoreId);
}

export function useCustomerTypes(groupStoreId: number) {

    return useQuery<CustomerType[], Error>({
        queryKey: ['types', groupStoreId],
        queryFn: () => fetchTypes(groupStoreId),
        staleTime: 300000,
        cacheTime: 600000,
    });
}
